  $('.accordion__title').on('click',
    ()->
      $parent = $root = $(this).closest('.accordion')
      $parent.removeClass('is-close')
      $parent.toggleClass('is-open')
      parentContentsHeight = rootContentsHeight = $parent.find('> .accordion__contents > .accordion__contents__inner').outerHeight()

      if $parent.hasClass('is-open')
        $parent.find('> .accordion__contents').css({
          'height': parentContentsHeight
          'maxHeight': parentContentsHeight
        })
      else
        $parent.find('> .accordion__contents').removeAttr('style')

      if $parent.hasClass('is-open-all')
        $parent.toggleClass('is-open-all')
        $parent.addClass('is-close-all')
      else if $parent.hasClass('is-close-all')
        $parent.toggleClass('is-close-all')
        $parent.addClass('is-open-all')

      if $parent.hasClass('js-subaccordion')
        $root = $parent.parents('.js-accordion')
        rootContentsHeight = $root.find('> .accordion__contents > .accordion__contents__inner').outerHeight()

        if $root.hasClass('is-open') and $parent.hasClass('is-open')
          $root.addClass('is-open-all')
        else
          $root.removeClass('is-open-all')

        if $root.hasClass('is-open')
          if $root.hasClass('is-open-all')
            allContentsHeight = if parentContentsHeight isnt rootContentsHeight then rootContentsHeight + parentContentsHeight else parentContentsHeight
          else
            allContentsHeight = if parentContentsHeight isnt rootContentsHeight then rootContentsHeight - parentContentsHeight else parentContentsHeight

          $root.find('> .accordion__contents').removeAttr('style')
          $root.find('> .accordion__contents').css({
            'height': allContentsHeight
            'maxHeight': allContentsHeight
          })

      $parent.on('oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend',
        ()->
          if not $parent.hasClass('is-open')
            $parent.addClass('is-close')
      )
  )
